import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { TextInput } from '../../../../../components'

/**
 * Name Detail
 */
class NameDetail extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { values, errors, onChange } = this.props

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title'>Name Detail</div>
        </Grid>

        <Grid item xs={12} container spacing={3} direction='column'>
          <Grid item xs={4}>
            <div className='field field--text'>
              <label className='field_label'>Salutation</label>
              <TextInput
                id='salutation'
                value={values.salutation}
                onChange={onChange} />
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className='field field--text'>
              <label className='field_label'>Nickname</label>
              <TextInput
                id='nickName'
                value={values.nickName}
                onChange={onChange} />
            </div>
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs={4}>
            <div className='field field--text'>
              <label className='field_label'>First Name <span
                className='required'>(required)</span></label>
              <TextInput
                id='firstName'
                error={errors.firstName}
                value={values.firstName}
                onChange={onChange} />
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className='field field--text'>
              <label className='field_label'>Last Name <span
                className='required'>(required)</span></label>
              <TextInput
                id='lastName'
                error={errors.lastName}
                value={values.lastName}
                onChange={onChange} />
            </div>
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={3} direction='column'>
          <Grid item xs={4}>
            <div className='field field--text'>
              <label className='field_label'>Suffix</label>
              <TextInput
                id='suffixProf'
                value={values.suffixProf}
                onChange={onChange} />
            </div>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

NameDetail.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default NameDetail
